import { Component, effect, inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseChartDirective } from 'ng2-charts';
import { BarChartService as ChartService } from '../../../services/bar-chart.service';

@Component({
  selector: 'app-horizontal-bars-modal',
  templateUrl: './horizontal-bars-modal.component.html',
  providers: [ChartService],
  standalone: false,
})
export class HorizontalBarsModalComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  readonly dialogRef = inject(MatDialogRef<HorizontalBarsModalComponent>);

  readonly data = inject(MAT_DIALOG_DATA);

  // #region     BEGIN ChartService
  readonly chartService$ = inject(ChartService);

  get data$() {
    return this.chartService$.data$;
  }

  readonly updateChartEffect$ = effect(() => {
    this.chartService$.barChartData$();
    this.chart?.update();
  });
  // #endregion  END ChartService

  ngOnInit(): void {
    this.data$.set(this.data);
  }
}
